import { default as MuiMenuList } from '@mui/material/MenuList';

/**
 * MenuList is a list of menu items, used within Menu.
 *
 * Demos:
 *
 * - [Menu](https://unify.workiva.org/components/menu?tab=code)
 *
 * API:
 *
 * - [MenuList API](https://unify.workiva.org/components/menu?tab=props#menulist)
 */
export const MenuList = MuiMenuList;
export { type MenuListProps } from '@mui/material/MenuList';
